import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import Link from 'next/link';
import Image from 'next/legacy/image';
import styled from 'styled-components';
import { useTranslation } from '@yoweb/next-i18next';
import { media, pxToRem } from '@yoweb/ui/styles/utils';
import { th } from '@yoweb/ui/styles/utils/theme';
import { Flex } from '@yoweb/ui/components/Flex';
import { Grid } from '@yoweb/ui/components/Grid';
import { Text } from '@yoweb/ui/components/typography/Text';
import { Title } from '@yoweb/ui/components/typography/Title';
import { Button } from '@yoweb/ui/components/buttons/Button';
import { InsetLink } from '@poplar/components/InsetLink';
import { CallCard } from '@poplar/components/CallCard';
import { PAGE_PROFILE } from '@poplar/constants/routes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FooterBannerSubscribed = function FooterBannerSubscribed() {
  var _useTranslation = useTranslation('home'),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(CallCard, {
    p: "none",
    overflow: "hidden",
    my: "normal2",
    hoverable: true,
    children: /*#__PURE__*/_jsxs(BannerGrid, {
      flow: {
        _: 'row',
        lg: 'column'
      },
      columns: {
        _: 'auto',
        md: "".concat(pxToRem(250), " 1fr"),
        lg: "".concat(pxToRem(346), " 1fr")
      },
      gap: "none",
      "data-testid": "home-footer-subscribed-view",
      children: [/*#__PURE__*/_jsx(Link, {
        href: PAGE_PROFILE,
        passHref: true,
        legacyBehavior: true,
        children: /*#__PURE__*/_jsx(InsetLink, {})
      }), /*#__PURE__*/_jsx(ImageWrapper, {
        children: /*#__PURE__*/_jsx(Image, {
          src: {
            src: '/images/illustrations/two-people-high-five.svg',
            width: 300,
            height: 152
          }
        })
      }), /*#__PURE__*/_jsxs(BodyWrapper, {
        flexDirection: "column",
        children: [/*#__PURE__*/_jsxs(ContentGrid, {
          gap: "small3",
          children: [/*#__PURE__*/_jsx(Title, {
            size: "sm",
            children: t('footer.subscribed.title')
          }), /*#__PURE__*/_jsx(Text, {
            children: t('footer.subscribed.description')
          })]
        }), /*#__PURE__*/_jsx(Link, {
          href: PAGE_PROFILE,
          passHref: true,
          legacyBehavior: true,
          children: /*#__PURE__*/_jsx(Button, {
            as: "a",
            children: t('footer.subscribed.edit-profile-link-text')
          })
        })]
      })]
    })
  });
};
var ContentGrid = styled(Grid).withConfig({
  componentId: "sc-1ej84gg-0"
})(["&&{max-width:", ";}"], pxToRem(450));
var BodyWrapper = styled(Flex).withConfig({
  componentId: "sc-1ej84gg-1"
})(["&&{background:", ";margin:3rem;align-items:center;text-align:center;justify-content:center;gap:", ";", "}"], th.getColor('base000'), th.getSpace('normal3'), media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      text-align: left;\n      align-items: flex-start;\n    "]))));
var BannerGrid = styled(Grid).withConfig({
  componentId: "sc-1ej84gg-2"
})(["&&{min-height:", ";grid-auto-rows:1fr 1fr;", "}"], pxToRem(255), media.md(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      grid-auto-rows: auto;\n    "]))));
var ImageWrapper = styled(Flex).withConfig({
  componentId: "sc-1ej84gg-3"
})(["&&{justify-content:center;background:", ";}"], th.getColor('lilac'));